import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { ApiBaseService } from '../api-base.service';
const BASE_URL = '/categories';
@Injectable({
  providedIn: 'root'
})
export class CategoriesService extends ApiBaseService {  

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(categoryId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${categoryId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(categoryId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${categoryId}`), data);
  }

  delete(categoryId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${categoryId}`));
  }

}
